module.exports = __webpack_public_path__ + "img/selections-5.webp";